/* Manual taxonomy; server-side Shopify facets and pagination own product results. */
(() => {
  if (window.lbCatalogBooted) { window.lbCatalogBooted(); return; }
  const readJSON = (root, selector, fallback = []) => {
    try { return JSON.parse(root.querySelector(selector)?.textContent || JSON.stringify(fallback)); } catch (_) { return fallback; }
  };
  function parseMap(raw) {
    const rows = [], errors = [];
    raw.split(/\r?\n/).forEach((line, index) => {
      if (!line.trim()) return;
      const parts = line.split('|');
      const path = (parts[0] || '').split('>').map(s => s.trim());
      const types = (parts[1] || '').split(';').map(s => s.trim()).filter(Boolean);
      if (parts.length !== 2 || path.some(s => !s) || !types.length) {
        errors.push(`Redak ${index + 1}: upišite putanju | TOČAN TYPE; DRUGI TYPE.`); return;
      }
      rows.push({ path, types: [...new Set(types)] });
    });
    return { rows, errors };
  }
  const rawMap = root => root.querySelector('[data-lb-tree-map]')?.content.textContent || '';
  function makeTree(rows) {
    const tree = { children: [], types: new Set() };
    rows.forEach(row => {
      let node = tree;
      row.path.forEach(name => {
        let next = node.children.find(n => n.name === name);
        if (!next) { next = { name, children: [], types: new Set() }; node.children.push(next); }
        row.types.forEach(type => next.types.add(type));
        node = next;
      });
    });
    return tree;
  }
  function initTree(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const { rows } = parseMap(rawMap(root));
    const output = root.querySelector('[data-lb-tree-output]');
    if (!output) return;
    if (!rows.length) { const p = document.createElement('p'); p.textContent = 'Odaberite vrstu proizvoda u filtrima ispod.'; output.append(p); return; }
    if (root.dataset.enabled !== 'true') { const p = document.createElement('p'); p.textContent = 'Filtriranje kategorija trenutačno nije dostupno.'; output.append(p); return; }
    const values = readJSON(root, '[data-lb-type-values]');
    const byType = new Map(values.map(v => [v.value, v]));
    const current = new URL(location.href);
    const selected = new Set(current.searchParams.getAll('filter.p.product_type').flatMap(s => s.split(',')));
    const urlFor = types => {
      const url = new URL(current);
      url.searchParams.delete('page'); url.searchParams.delete('filter.p.product_type');
      // Repeated parameters preserve product types containing punctuation safely.
      types.forEach(type => url.searchParams.append('filter.p.product_type', type));
      return url.pathname + url.search + url.hash;
    };
    const all = document.createElement('a'); all.className = 'lb-tree-all'; all.href = urlFor([]); all.textContent = 'Sve kategorije'; output.append(all);
    function renderNodes(nodes, depth = 0, path = []) {
      const ul = document.createElement('ul');
      nodes.forEach((node, i) => {
        const li = document.createElement('li'), row = document.createElement('div'); row.className = 'lb-tree-row';
        const matches = [...node.types].filter(t => selected.has(t));
        const exact = matches.length === selected.size && selected.size === node.types.size && selected.size > 0;
        let toggle, children;
        if (node.children.length) {
          toggle = document.createElement('button'); toggle.type = 'button'; toggle.className = 'lb-tree-toggle'; toggle.textContent = '›';
          toggle.dataset.lbTreeKey = [...path, node.name].join(' > ');
          toggle.setAttribute('aria-label', (matches.length ? 'Zatvori' : 'Otvori') + ' podkategorije: ' + node.name);
          toggle.setAttribute('aria-expanded', String(matches.length > 0)); row.append(toggle);
        } else { const spacer = document.createElement('span'); spacer.className = 'lb-tree-spacer'; row.append(spacer); }
        const a = document.createElement('a'); a.className = 'lb-tree-link'; a.href = urlFor([...node.types]); a.textContent = node.name;
        if (exact) a.setAttribute('aria-current', 'true');
        if (matches.length) row.classList.add('is-active-branch');
        // With one child a parent can have the same types: frame only the deepest matching row.
        if (exact && !node.children.some(child => child.types.size === node.types.size)) row.classList.add('is-selected');
        if ([...node.types].every(t => byType.has(t))) {
          const count = document.createElement('small'); count.textContent = [...node.types].reduce((sum, t) => sum + Number(byType.get(t).count || 0), 0); a.append(count);
        }
        row.append(a); li.append(row);
        if (toggle) {
          children = renderNodes(node.children, depth + 1, [...path, node.name]); children.hidden = !matches.length;
          children.id = 'lb-tree-' + Math.random().toString(36).slice(2); toggle.setAttribute('aria-controls', children.id);
          toggle.textContent = children.hidden ? '›' : '⌄';
          toggle.addEventListener('click', () => {
            children.hidden = !children.hidden; toggle.setAttribute('aria-expanded', String(!children.hidden)); toggle.textContent = children.hidden ? '›' : '⌄';
            toggle.setAttribute('aria-label', (children.hidden ? 'Otvori' : 'Zatvori') + ' podkategorije: ' + node.name);
          }); li.append(children);
        }
        ul.append(li);
      }); return ul;
    }
    output.append(renderNodes(makeTree(rows).children));
    // Native type choices stay accessible: unmapped types must never disappear.
  }
  function initAudit(root) {
    if (root.dataset.ready) return; root.dataset.ready = 'true';
    const { rows, errors } = parseMap(rawMap(root));
    const allTypes = readJSON(root, '[data-lb-all-types]').filter(t => typeof t === 'string' && t.trim());
    const assignments = new Map();
    rows.forEach(row => row.types.forEach(type => { if (!assignments.has(type)) assignments.set(type, []); assignments.get(type).push(row.path.join(' → ')); }));
    const missing = allTypes.filter(t => !assignments.has(t));
    const unknown = [...assignments.keys()].filter(t => !allTypes.includes(t));
    const duplicate = [...assignments].filter(([, paths]) => paths.length > 1).map(([type, paths]) => type + ': ' + paths.join(' / '));
    const output = root.querySelector('[data-lb-category-audit]');
    [['Neraspoređeni product typeovi', missing], ['Nepoznati nazivi — provjerite točan zapis', unknown], ['Višestruke dodjele — provjerite jesu li namjerne', duplicate], ['Neispravni redci', errors]].forEach(([title, items]) => {
      const h = document.createElement('h3'); h.textContent = `${title} (${items.length})`; output.append(h);
      if (!items.length) { const p = document.createElement('p'); p.textContent = 'Sve uredno.'; output.append(p); return; }
      const list = document.createElement('ul'); list.className = 'lb-audit-list';
      items.forEach(item => { const li = document.createElement('li'); li.textContent = item; list.append(li); }); output.append(list);
    });
    if (missing.length) {
      const button = document.createElement('button'); button.type = 'button'; button.textContent = 'Kopiraj neraspoređene tipove';
      button.addEventListener('click', async () => { try { await navigator.clipboard.writeText(missing.join('\n')); button.textContent = 'Kopirano'; } catch (_) { button.textContent = 'Označite i kopirajte popis iznad.'; } }); output.append(button);
    }
  }
  function initCatalog(root) {
    if (root.dataset.ready) return; root.dataset.ready = 'true';
    const panel = root.querySelector('[data-lb-filter-panel]');
    if (panel) {
      const media = matchMedia('(max-width:900px)'); const update = () => panel.open = !media.matches; update(); media.addEventListener('change', update);
    }
    root.querySelectorAll('.lb-b2b-qty').forEach(wrap => {
      const input = wrap.querySelector('input');
      const normalize = () => {
        const min = Number(input.min || 1), step = Number(input.step || 1), max = input.max === '' ? Infinity : Number(input.max);
        const entered = Number(input.value); let val = Number.isFinite(entered) ? entered : min;
        val = min + Math.max(0, Math.round((val - min) / step)) * step;
        input.value = Math.min(val, max >= min ? min + Math.floor((max - min) / step) * step : min);
      };
      wrap.querySelector('[data-qty-minus]')?.addEventListener('click', () => { input.value = Number(input.value) - Number(input.step || 1); normalize(); });
      wrap.querySelector('[data-qty-plus]')?.addEventListener('click', () => { input.value = Number(input.value) + Number(input.step || 1); normalize(); });
      input.addEventListener('change', normalize);
    });
    root.querySelectorAll('[data-lb-catalog-wishlist]').forEach(button => {
      const get = () => { try { const data = JSON.parse(localStorage.getItem('lb-wishlist') || '[]'); return new Set(Array.isArray(data) ? data.map(String) : []); } catch (_) { return new Set(); } };
      const refresh = () => { const saved = get().has(button.dataset.lbCatalogWishlist); button.setAttribute('aria-pressed', String(saved)); button.setAttribute('aria-label', saved ? 'Ukloni s liste želja' : 'Spremi na listu želja'); };
      refresh(); button.addEventListener('click', () => { try { const ids = get(), id = button.dataset.lbCatalogWishlist; if (ids.has(id)) ids.delete(id); else ids.add(id); localStorage.setItem('lb-wishlist', JSON.stringify([...ids])); refresh(); } catch (_) {} });
    });

  }
  const boot = () => {
    document.querySelectorAll('[data-lb-tree]').forEach(initTree);
    document.querySelectorAll('[data-lb-category-admin]').forEach(initAudit);
    document.querySelectorAll('[data-lb-catalog]').forEach(initCatalog);
  };
  window.lbCatalogBooted = boot;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
